import GoogleAnalytics from 'react-ga';

export default function(customer) {
  GoogleAnalytics.set({dimension2: String(customer)});
}
